import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

type AutoRedirectProps = {
  to: string;
  shouldRedirect: boolean;
  children: ReactNode;
};

function AutoRedirect({ to, shouldRedirect, children }: AutoRedirectProps) {
  const { search } = useLocation();
  if (!shouldRedirect) return children;

  // `to` may already carry a query string, which React Router rejects in `pathname`.
  const [pathname, targetSearch = ""] = to.split("?");
  const params = new URLSearchParams(search);
  const targetParams = new URLSearchParams(targetSearch);
  new Set(targetParams.keys()).forEach((key) => params.delete(key));
  targetParams.forEach((value, key) => params.append(key, value));
  const mergedSearch = params.toString();

  return (
    <Navigate
      replace
      to={{ pathname, search: mergedSearch ? `?${mergedSearch}` : "" }}
    />
  );
}

export default AutoRedirect;
